import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5 bg-#f9f9fb" }
const _hoisted_2 = { class: "headerDiv" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "row w-full flex justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mainContainer pb-5 w-full h-full bg-white" }
const _hoisted_9 = { class: "mt-5 mx-5 flex flex-row borderBottom overflow-hidden cursor-pointer font-semibold tab-container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "selectedTabs px-5" }
const _hoisted_12 = {
  key: 0,
  class: "w-full h-full"
}
const _hoisted_13 = { class: "tableDataStyling" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "inputBoxWithSaveIcon" }
const _hoisted_17 = { class: "inputBoxInDiv" }
const _hoisted_18 = { class: "flex justify-between mb-6" }
const _hoisted_19 = { class: "colorLabelWidth" }
const _hoisted_20 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_21 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_22 = { class: "descriptionStyle" }
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_25 = { class: "flex items-center justify-center" }
const _hoisted_26 = { class: "flex justify-center align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "pt-1" }, "Information Classification", -1)),
        (_ctx.selectedTabIndex === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateMapScreen && _ctx.navigateMapScreen(...args)))
              }, "Map"),
              _createElementVNode("button", {
                class: _normalizeClass(["flex", _ctx.filteredInformations.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.filteredInformations.length == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                _cache[6] || (_cache[6] = _createTextVNode(" Filters "))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
        _createElementVNode("div", null, " Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a filie folder, where we keep important documents, you'll need to arrange your data in the most logical and orderly fashion, so you and anyone else who accesses it can easily find what they're looking for. Data organization is the practice of categorizing and classifying data to make mone usable. Similar to a file folder, where we keep important documents, you'll need to arrange your data in the most logical and orderly fashion. ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab, tabIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "pb-1 mt-3 adjust",
              key: tabIndex,
              onClick: ($event: any) => (_ctx.toggleTabs(tab.id))
            }, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "actualIndex",
                class: _normalizeClass(["tab-name", _ctx.selectedTabIndex == tab.id?'header text-primary':'text-disabledgrey'])
              }, _toDisplayString(tab.displayName), 3),
              _createElementVNode("div", {
                class: _normalizeClass([{ progress: _ctx.selectedTabIndex == tab.id }, "h-1 p-0.75"])
              }, null, 2)
            ], 8, _hoisted_10))
          }), 128))
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "progressbarB rounded-sm ml-5 mr-5 relative h-1 mx-2.5" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.selectedTabIndex == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_newTable, {
                  tableRowData: _ctx.filteredInformations,
                  headersData: _ctx.headersInfo,
                  openPopup: true,
                  loadData: _ctx.dataLoading
                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                (_ctx.toolTipActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs font-semibold mb-1" }, "Label", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["inputboxstyling", {
                                            'is-invalid': _ctx.v$.infoProperties.label.$error
                                        }]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.infoProperties.label) = $event)),
                        placeholder: "Label for the Classification"
                      }, null, 2), [
                        [_vModelText, _ctx.infoProperties.label]
                      ]),
                      (_ctx.v$.infoProperties.label.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_ctx.v$.infoProperties.label.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs font-semibold mb-1" }, "Description", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        class: _normalizeClass(["w-full e9BorderStyling resize-none p-2 text-sm rounded", {
                                            'is-invalid': _ctx.v$.infoProperties.description.$error
                                        }]),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.infoProperties.description) = $event)),
                        placeholder: "Input field to describe about Classification of Information "
                      }, null, 2), [
                        [_vModelText, _ctx.infoProperties.description]
                      ]),
                      (_ctx.v$.infoProperties.description.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_ctx.v$.infoProperties.description.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args))),
                        class: _normalizeClass(["mr-2", JSON.stringify(_ctx.infoPropertiesDummy) == JSON.stringify(_ctx.infoProperties) ? 'btndisabled pointer-events-none' : 'btnprimary'])
                      }, "Reset", 2),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateClassification && _ctx.updateClassification(...args))),
                        class: _normalizeClass(["ml-2", JSON.stringify(_ctx.infoPropertiesDummy) == JSON.stringify(_ctx.infoProperties) ? 'btndisabled pointer-events-none' : 'btnprimary'])
                      }, "Update", 2)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}